var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('responsive-controller', {
    scopedSlots: _vm._u([{
      key: "tablet",
      fn: function fn() {
        return [_c('project-dashboard-mobile-template', {
          attrs: {
            "project": _vm.PROJECT_INFO,
            "graph": _vm.GRAPH
          }
        })];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_c('project-dashboard-desktop-template', {
          attrs: {
            "project": _vm.PROJECT_INFO,
            "graph": _vm.GRAPH
          }
        })];
      },
      proxy: true
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }